
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-grid-list .product-list-card").forEach(function (card) {
    productDataUpdate(card, false);
  });
  document.querySelectorAll(".related-product-card").forEach(function (card) {
    productDataUpdate(card, false);
  });
  document.querySelectorAll(".pdp-main-wrapper").forEach(function (card) {
    productDataUpdate(card, true);
  });
  document.querySelectorAll(".custom-pdp-two-col-section").forEach(function (card) {
    productDataUpdate(card, true);
  });
  document.querySelectorAll(".product-card-wrapper").forEach(function (card) {
    productDataUpdate(card, false);
  });
});
/*
// Select your target UL
const targetUl = document.querySelector('ul.product-grid'); // change selector to your specific UL

if (targetUl) {
  const observer = new MutationObserver(mutationsList => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {

        // Handle added LIs
        [...mutation.addedNodes].forEach(node => {
          if (node.nodeType === 1 && node.tagName === 'LI') {
            onListChange('added', node);
          }
        });

        // Handle removed LIs
        [...mutation.removedNodes].forEach(node => {
          if (node.nodeType === 1 && node.tagName === 'LI') {
            onListChange('removed', node);
          }
        });

      }
    }
  });

  observer.observe(targetUl, { childList: true, subtree: false });

  // Your custom handler
  function onListChange(action, liElement) {
    console.log(`LI ${action}:`, liElement);
    // 💡 Put your custom logic here
    document.querySelectorAll(".product-grid-list .product-list-card").forEach(function (card) {
    productDataUpdate(card, false);
  });
  }
} else {
  console.warn('Target UL not found!');
}*/


function productDataUpdate(card, isPDP){
  console.log("product data update"+isPDP);
  
  let buttons = card.querySelectorAll(".product-selector-color");
  if (buttons.length === 0) {
    buttons = card.querySelectorAll(".product-selector-options");
  }
  const imageEl = card.querySelector("[data-product-image]");
  const priceEl = card.querySelector("[data-actual-price]");
  const comparePriceEl = card.querySelector("[data-compare-price]");
  const pdpImageEls = card.querySelectorAll(".pdp-image-video-wrap");
  const buyButtonEl = card.querySelector("[data-buyButton]");
  const cardAnchorEls = card.querySelectorAll("a[data-product-url]");
  const productInfoTextEl = card.querySelector(".product-details .product-info-text[data-product-info]");

  const addToCartText = card.getAttribute("data-addToCartText");
  const soldOutText = card.getAttribute("data-soldOutText");
  
  buttons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      // Remove active class
            console.log('swatch clicked');
      buttons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
  
      const productId = btn.getAttribute("data-product-id");
      const variantId = btn.getAttribute("data-variant-id");
      const img = btn.getAttribute("data-image");
      const price = btn.getAttribute("data-price");
      const compareAtPrice = btn.getAttribute("data-compare-at-price");
      const availability = btn.getAttribute("data-availability");
      const variantURL = btn.getAttribute("data-url");
      const product_color = btn.getAttribute("data-color");
      const isComingSoon = btn.getAttribute("data-coming-soon")=='true';
      //console.log(variantId+' '+productId);
  
      // Update image
      console.log(isPDP);
      if(isPDP){
        if(pdpImageEls){
          const btnDataLink = btn.getAttribute("data-link");
          pdpImageEls.forEach(el => {
            if (el.getAttribute("data-id") === btnDataLink) {
              el.classList.add("active");
            } else {
              el.classList.remove("active");
            }
          });
        }

        const colorText = document.querySelector(".color-text");
    
        if (colorText) {
            colorText.textContent = product_color;
        }
        if (product_color){
           const variantGalleryImages = document.querySelectorAll('.variant-color-image-'+product_color);
           if (variantGalleryImages.length > 0) {
              $('.variant-gallery-images').hide();
               variantGalleryImages.forEach(el => {
                el.style.display = 'block';
              });
           }
        }
                
        
        // Update for PDP Top sticky bar start
        const pdpTopBarEl = document.querySelector(".pdp-top-sticky-bar");
        
        if (pdpTopBarEl) {
          const pdpTopBuyButtonEl = pdpTopBarEl.querySelector("[data-buyButton]");
          const pdpTopBuyButtonTextEls = pdpTopBuyButtonEl?.querySelectorAll("[data-buyButtonText]");
          const actualPriceEl = pdpTopBarEl.querySelector("[data-actual-price]");
          const comparePriceEle = pdpTopBarEl.querySelector("[data-compare-price]");
        
          if (pdpTopBuyButtonEl && pdpTopBuyButtonTextEls && !isComingSoon) {
            if (availability === 'true' || availability === true) {
              pdpTopBuyButtonTextEls.forEach(el => {
                el.textContent = addToCartText || "Buy now";
              });
              pdpTopBuyButtonEl.removeAttribute("disabled");
            } else {
              pdpTopBuyButtonTextEls.forEach(el => {
                el.textContent = soldOutText || "Not available";
              });
              pdpTopBuyButtonEl.setAttribute("disabled", "");
            }
          }
        
          if (actualPriceEl) {
            actualPriceEl.textContent = price;
          }
        
          if (comparePriceEle) {
            if (compareAtPrice && compareAtPrice !== price) {
              comparePriceEle.style.display = 'inline-block';
              comparePriceEle.textContent = compareAtPrice;
            } else {
              comparePriceEle.style.display = 'none';
            }
          }
        }
        //end
        
        document.querySelectorAll('.form-variant-id-' + productId).forEach(el => {
          el.value = variantId;
        });
        
      }else{
        //document.querySelector('.form-variant-id-'+productId).value = variantId;
        const input = document.querySelector('.form-variant-id-' + productId);
        if (input) {
          input.value = variantId;
        } else {
          console.warn('No element found with class: .form-variant-id-' + productId);
        }
        
        if (img && imageEl) {
          imageEl.src = img;
        }

        //Update variant url 
        cardAnchorEls.forEach(el => {
          el.href = variantURL;
        });
        
      }

      // Update addtocart button text
      if(buyButtonEl && !isComingSoon){
          const buttonTextEls = buyButtonEl.querySelectorAll("[data-buyButtonText]");
          
          if (availability === 'true' || availability === true) {
            buttonTextEls.forEach(el => {
              el.textContent = addToCartText || "Buy now";
            });
            buyButtonEl.removeAttribute("disabled");
            productInfoTextEl.style.display = 'none';
          } else {
            buttonTextEls.forEach(el => {
              el.textContent = soldOutText || "Not available";
            });
            buyButtonEl.setAttribute("disabled", "");
            productInfoTextEl.style.display = 'block';
          }
      }
  
      // Update actual price
      if (priceEl) {
        priceEl.textContent = price;
      }
  
      // Update compare at price (or hide if not applicable)
      if (comparePriceEl) {
        if (compareAtPrice && compareAtPrice !== price) {
          comparePriceEl.style.display = 'inline-block';
          comparePriceEl.textContent = compareAtPrice;
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
    });
  });
}  

/** Menu hover image start */
function handleMegaMenuImageSwap() {
  $(".mega-menu-links-col a").off("mouseenter click");

  if ($(window).width() > 1023) {
    //Main menu
    $(".main-nav-list a").on("mouseenter", function () {
      const newImage = $(this).data("image");
      const mainMenuId = $(this).data("id");
      
     if (newImage && mainMenuId) {
        $("#hover-image-" + mainMenuId).attr("src", newImage);
      }
    });

    //navigation menu sub
    $(".mega-menu-links-col a").on("mouseenter", function () {
      const newImage = $(this).data("image");
      const mainMenuId = $(this).data("id");
      if (newImage && mainMenuId) {
        $("#hover-image-" + mainMenuId).attr("src", newImage);
      }
    });
  } else {
    $(".main-nav-list a").on("click", function () {
      const newImage = $(this).data("image");
      if (newImage) {
        $("#mobile-hover-image").attr("src", newImage);
      }
    });
    $(".mega-menu-links-col a").on("click", function () {
      const newImage = $(this).data("image");
      if (newImage) {
        $("#mobile-hover-image").attr("src", newImage);
      }
    });
  }
}

$(document).ready(handleMegaMenuImageSwap);
// Run on window resize
$(window).on("resize", handleMegaMenuImageSwap);

/*** Menu hover image end **/

$(document).ready(function () {
  $(".shopping-btn").on("click", function () {
    const cartDrawerCloseBtn = $(".cart-drawer__close-button");
    if (cartDrawerCloseBtn.length) {
      setTimeout(() => {
        cartDrawerCloseBtn.trigger("click");
      }, 300);
    }
  });

   // Close cart drawer when clicking outside it (on body)
    //$(document).on("click", function (e) {
    $(".cart-drawer .cart-overlay").on("click", function (e) {
      console.log("body click");
      const $cartDrawer = $(".cart-drawer");
      const $closeBtn = $(".cart-drawer__close-button");
  
      $closeBtn.trigger("click");
    });

  // Prevent body click from closing drawer when clicking inside it
  $(".cart-drawer").on("click", function (e) {
    e.stopPropagation();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.quantity-select').forEach(function (selectEl) {
    selectEl.addEventListener('change', function (event) {
      const quantity = event.target.value;
      const dataId = selectEl.dataset.id;

      const quantityWrapper = selectEl.closest('.cart-item')?.querySelector('quantity-selector-component');

      if (!quantityWrapper) return;
      const inputEl = quantityWrapper.querySelector('.quantity_input'+dataId);
      if (!inputEl) return;
  
      inputEl.value = quantity;
      inputEl.dispatchEvent(new Event('blur', { bubbles: true }));
    });
  });
});

document.addEventListener('change', function(event) {
  if (event.target.matches('.quantity-select')) {
  
    const selectEl = event.target;
    const quantity = selectEl.value;
    const dataId = selectEl.dataset.id;

    const quantityWrapper = selectEl.closest('.cart-item')?.querySelector('quantity-selector-component');

    const inputEl = quantityWrapper.querySelector('.quantity_input' + dataId);
    if (!inputEl) return;

    inputEl.value = quantity;
    inputEl.dispatchEvent(new Event('blur', { bubbles: true }));
  }
});

$(document).ready(function () {
  const currentUrl = window.location.pathname;
  $(".inner-page-navbar ul li a").removeClass("active");
  $(".inner-page-navbar ul li a").each(function () {
    const linkHref = $(this).attr("href");
    // console.log(linkHref + ' '+ currentUrl);
    // Skip empty href or just "#"
    if (!linkHref || linkHref === "#") return;

    // Add active only if URL matches exactly or contains the path
    if (currentUrl.indexOf(linkHref) !== -1 && linkHref !== "/") {
      $(this).addClass("active");
    }
  });
});

/** Start Blog page menu filters **/
document.addEventListener('DOMContentLoaded', function () {
  const currentUrl = window.location.href;
  const tabLinks = document.querySelectorAll('.blog-listing-filter ul li a');

  tabLinks.forEach(function (link) {
    const linkHref = link.getAttribute('href');
    if (currentUrl.includes(linkHref) && linkHref.includes('/tagged/')) {
      document.querySelectorAll('.blog-listing-filter ul li').forEach(el => el.classList.remove('current'));
      link.closest('li').classList.add('current');
    }
  });
});
/** End Blog page menu filters **/


document.addEventListener("DOMContentLoaded", function () {
  const tocList = document.querySelector('.top-content .sidebar');
  const article = document.querySelector('.article-template');

  if (!tocList || !article) return;

  const headings = article.querySelectorAll('h2.scroll-section, h3.scroll-section');


  function generateId(text) {
    // Only take first part before comma (if any)
    let baseText = text.split(',')[0];
    return baseText
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')        // Remove punctuation
      .replace(/\s+/g, '-')            // Replace spaces with hyphens
      .replace(/-+/g, '-');            // Remove repeated dashes
  }

  const usedIds = new Set();

  headings.forEach((heading, index) => {
    let id = generateId(heading.textContent);

    // Ensure unique ID if duplicate exists
    let uniqueId = id;
    let suffix = 1;
    while (usedIds.has(uniqueId)) {
      uniqueId = `${id}-${suffix++}`;
    }
    usedIds.add(uniqueId);

    heading.setAttribute('id', uniqueId);

    const li = document.createElement('li');
    li.setAttribute('data-target', `#${uniqueId}`);
    if (index === 0) li.classList.add('active-slide');

    const button = document.createElement('button');
    button.textContent = heading.textContent;

    li.appendChild(button);
    tocList.appendChild(li);
  });

  // Scroll and set active class
  document.querySelectorAll('.toc-list li button').forEach(btn => {
    btn.addEventListener('click', function () {
      const targetId = this.parentElement.getAttribute('data-target');
      const target = document.querySelector(targetId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // Update active-slide
      document.querySelectorAll('.toc-list li').forEach(li => li.classList.remove('active-slide'));
      this.parentElement.classList.add('active-slide');
    });
  });
});


/*** Collection List Start ****/
function applyFilters() {
  console.log("applyFilters");

  const selectedColors = [...document.querySelectorAll('.filter-color:checked')].map(el => el.value.toLowerCase());
  const selectedCategories = [...document.querySelectorAll('.filter-category:checked')].map(el => el.value.toLowerCase());
  const selectedFeatures = [...document.querySelectorAll('.filter-feature:checked')].map(el => el.value.toLowerCase());

  let visibleCount = 0;
  console.log(selectedColors);

  document.querySelectorAll('.product-list-card.collection_page').forEach(card => {
    const productTags = (card.dataset.tags || '')
      .split(',')
      .map(tag => tag.trim().toLowerCase());

    const productColor = (card.dataset.color || '')
      .split(',')
      .map(color => color.trim().toLowerCase());

    const title = card.dataset.title || 'No Title';

    const categoryTagMatch = selectedCategories.length === 0 ||
      selectedCategories.some(cat => productTags.includes(`category-${cat}`));

    const colorMatch = selectedColors.length === 0 ||
      selectedColors.some(color => productColor.includes(color));

    const featuresTagMatch = selectedFeatures.length === 0 ||
      selectedFeatures.some(feature => productTags.includes(`feature-${feature}`));

      console.log(colorMatch+ title);

    const isVisible = categoryTagMatch && colorMatch && featuresTagMatch;

    if (isVisible) {
      card.style.display = 'block';
      visibleCount++;  
    } else {
      card.style.display = 'none';
    }
  });

  const countElement = document.getElementById('filter-result-count');
  if (countElement) {
    countElement.textContent = `${visibleCount} Product${visibleCount !== 1 ? 's' : ''}`;
  }

}
const applyFiltersButton = document.getElementById("apply-filters");
if (applyFiltersButton) {
  applyFiltersButton.addEventListener("click", applyFilters);
}



/*document.getElementById('custom-filters').addEventListener('submit', function (e) {
  console.log("submit");
  e.preventDefault();

  const form = e.target;
  const formData = new FormData(form);
  const params = new URLSearchParams();
console.log("params "+params);
  for (const [key, value] of formData.entries()) {
    params.append(key, value);
  }

  const collectionUrl = window.location.pathname;
  const filterUrl = `${collectionUrl}?${params.toString()}`;
  console.log(filterUrl);
  filterCollectionList(filterUrl);
  
});*/

document.querySelectorAll('input[type="radio"][name="sort_by"]').forEach((radio) => {
  radio.addEventListener('change', function () {
    const selectedValue = this.value;
    console.log('Selected sort option:', selectedValue);

    const collectionUrl = window.location.pathname;
    const filterUrl = `${collectionUrl}?sort_by=${selectedValue}`;

    filterCollectionList(filterUrl);
    document.querySelector(".sort-by-filter").textContent = this.dataset.sortby;
  });
});

function contentanimationForAjax() {
  const observer = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          $(entry.target).addClass("content-animate");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.05,
    }
  );
  $(".content-visible").each(function () {
    observer.observe(this);
  });
}


function filterCollectionList(filterUrl){
  fetch(filterUrl)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newProducts = doc.querySelector('#filtered-products');
      document.getElementById('filtered-products').innerHTML = newProducts.innerHTML;

      //applyFilters();
       const selectedColors = [...document.querySelectorAll('.filter-color:checked')].map(el => el.value.toLowerCase());
      const selectedCategories = [...document.querySelectorAll('.filter-category:checked')].map(el => el.value.toLowerCase());
      const selectedFeatures = [...document.querySelectorAll('.filter-feature:checked')].map(el => el.value.toLowerCase());
      
      console.log(selectedColors + selectedCategories);

      const count = document.querySelectorAll('#filtered-products li').length;
      document.querySelector('#filter-result-count').textContent = count+' Products';

      applyFilters();

      contentanimationForAjax();
      // Re-initialize
      document.querySelectorAll(".product-grid-list .product-list-card").forEach(function (card) {
        productDataUpdate(card, false);
      });
    });
}


function updateFilterCounts() {
  const checkboxes = document.querySelectorAll('.filter-checkbox-input');
  const counts = {};
  let anyChecked = false;

  checkboxes.forEach(cb => {
    if (cb.checked) {
      anyChecked = true;
      const type = cb.dataset.filtertype;
      counts[type] = (counts[type] || 0) + 1;
    }
  });

  const filterTypes = ['color', 'category', 'feature'];
  filterTypes.forEach(type => {
    // Support both desktop and mobile badges
    const badgeTypes = document.querySelectorAll(`.${type}-filter-badge`);
    badgeTypes.forEach(badgeType => {
      badgeType.style.display = counts[type] ? 'inline-flex' : 'none';
    });

    const badges = document.querySelectorAll(`#${type}-filter-badge-count`);
    badges.forEach(badge => {
      badge.textContent = counts[type] || 0;
    });
  });

  const sortTab = document.querySelector('.sort-by-tab');
  if (sortTab) {
    sortTab.classList.toggle("disabled", anyChecked);
  }
}
document.addEventListener('change', function (event) {
  if (event.target.classList.contains('filter-checkbox-input')) {
    updateFilterCounts();
  }
});

document.getElementById("clear-filter")?.addEventListener("click", () => {
	const collectionUrl = window.location.pathname;
    const filterUrl = `${collectionUrl}`;

    filterCollectionList(filterUrl);
    document.querySelector(".sort-by-filter").textContent = '';
});

document.getElementById("clear-all-filters")?.addEventListener("click", () => {
  // Uncheck all checkboxes in all filter groups
  document.querySelectorAll('.filter-color, .filter-category, .filter-feature')
    .forEach(input => input.checked = false);
  document.querySelectorAll('.filter-badge').forEach(badge => {
    badge.style.display = 'none';
  });
  document.querySelectorAll('.filter-badge-count').forEach(el => {
    el.textContent = '';
  });

  // Re-apply filter logic
  applyFilters();
});

document.querySelectorAll('.close-icon-btn').forEach(button => {
  button.addEventListener('click', () => {
    const filterType = button.dataset.filterType;

    // Uncheck all checkboxes of that filter group
    document.querySelectorAll(`.filter-${filterType}`).forEach(input => {
      input.checked = false;
    });

    // Hide the badge and clear count
    const badge = button.closest('.filter-badge');
    if (badge) {
      badge.style.display = 'none';
      const countSpan = badge.querySelector('span');
      if (countSpan) countSpan.textContent = '';
    }

    // Re-apply filtering
    applyFilters();
  });
});

/*** Collection List End ****/

/** sennheiser-consumer-ambassador-program iframe src start **/
$('.showIframeBtn').on('click', function () {
    $('.consumer-ambassador-iframe').toggleClass('active');
    $('body').toggleClass('consumer-ambassador-iframe-open');
});
/** sennheiser-consumer-ambassador-program iframe src end **/

// Show more button JS for collection page
document.addEventListener('click', function(e) {
  if (e.target.matches('.custom-collection-product-grid button.more-product[data-product-count-limit]')) {
    console.log("SHOW MORE CLICK");
    const hiddenItems = document.querySelectorAll('.custom-collection-product-grid .product-grid-list .product-list-card.hidden');
    hiddenItems.forEach(item => {
      item.classList.remove('hidden');
    });
    e.target.style.display = 'none';
  }
});
//End

function closeSortingDetailsMobile() {
  const detailsElements = document.querySelectorAll('.no-filter-yes-sorting .sorting-filter details[open]');
  detailsElements.forEach(el => el.removeAttribute('open'));
}

window.addEventListener('DOMContentLoaded', closeSortingDetailsMobile);
window.addEventListener('resize', closeSortingDetailsMobile);

//ACF custom pricing JS

var pricelist = getCookie("pricelist");
(() => {
  let external_price;
  let external_token;

  /** --------------------------
  * Build custom line item properties
  * -------------------------- */
  const buildCustomProperties = (external_price, external_token, pricelist) => {
    const properties = {};
    if (external_price) properties._external_price = external_price;
    if (external_token) properties._external_token = external_token;
    if (pricelist) properties._external_pricelist = pricelist;
    return properties;
  };

  /** --------------------------
  * Update cart count in header
  * -------------------------- */
  const updateCartCount = async (onReload) => {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();

      const countElem = document.querySelector('.header-actions__cart-icon .cart-bubble__text-count');
      if (countElem){
        countElem.textContent = cart.item_count;
      }else{
        document.querySelector('.header-actions__cart-icon').classList.add('header-actions__cart-icon--has-cart');
        document.querySelector('.header-actions__cart-icon .cart-bubble').classList.remove('visually-hidden');
        document.querySelector('.header-actions__cart-icon .cart-bubble__text').innerHTML = '<span class="visually-hidden">Total items in cart:' +cart.item_count+'</span><span class="cart-bubble__text-count" aria-hidden="true">'+cart.item_count+'</span>';
      } 
      if(!onReload){
        document.querySelector('.header-actions__cart-icon .cart-bubble').classList.toggle('cart-bubble--animating');
        setTimeout(function(){
          document.querySelector('.header-actions__cart-icon .cart-bubble').classList.remove('cart-bubble--animating');
        }, 300)
      }

    } catch (err) {
      console.error('❌ Error updating cart count:', err);
    }
  };

  updateCartCount(true);

  /** --------------------------
  * Bind add-to-cart events
  * -------------------------- */
  const buttons = document.querySelectorAll("product-form-component add-to-cart-component button[data-addToCartCustom]");
  if (!buttons.length) {
    console.warn('⚠️ No add-to-cart buttons found on page.');
    return;
  }

  buttons.forEach((button, index) => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();

      const form = button.closest('product-form-component');
      if (!form) {
        console.error('❌ product-form-component not found for this button');
        return;
      }

      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput || !variantInput.value) {
        console.error('❌ Variant ID not found inside form');
        return;
      }

      const variant = parseInt(variantInput.value);

      if (typeof pricelist !== 'undefined' && benefits[variant] && benefits[variant][pricelist]) {
        external_price = benefits[variant][pricelist].closed_shop_price;
        external_token = benefits[variant][pricelist].closed_shop_token;
      }

      const properties = buildCustomProperties(external_price, external_token, pricelist);

      const data = {
        id: variant,
        quantity: 1,
        properties
      };

      console.log(data)
      // Perform AJAX add-to-cart
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(data)
        });

        if (!response.ok) {
          const text = await response.text();
          throw new Error(`HTTP ${response.status}: ${text}`);
        }

        updateCartCount();

        const responseJson = await response.json()
        let toastMessageSuffix = 'added to cart'
        if(window.Weglot && typeof Weglot.getCurrentLang === 'function') {
          const currentLang = Weglot.getCurrentLang();
          if(currentLang === "fr-ca") {
            toastMessageSuffix = 'ajouté au panier'
          }
        }
        document.dispatchEvent(new CustomEvent('ShowToast', {
          detail: {
            titleText: `${responseJson.product_title} ${toastMessageSuffix}`
          }
        }));

      } catch (error) {
        console.error('❌ Error adding to cart:', error);
      }
    });
  });
})();


if (pricelist != undefined) {
  var c_variant_id;
  if(document.querySelector('.pdp-main-wrapper')){
    c_variant_id = parseFloat(document.querySelector('.pdp-main-wrapper product-form-component form.shopify-product-form input[name=id]').value);
  }else if(document.querySelector('.custom-pdp-two-col-section')){
    c_variant_id = parseFloat(document.querySelector('.custom-pdp-two-col-section product-form-component form.shopify-product-form input[name=id]').value);
  }
  
  for (var prop in benefits) {
    var closed_shop = benefits[prop][pricelist];
    if (closed_shop != undefined) {
      console.log('check: '+theme.moneyFormat);
      var money_formatted = formatMoney(closed_shop.closed_shop_price, theme.moneyFormat);
      var compare_at_price_formatted = formatMoney(closed_shop.compare_price, theme.moneyFormat);
      
      document.querySelectorAll('.product-price[data-variant-id="'+prop+'"] span[data-compare-price]').forEach(el => {
        el.innerText = compare_at_price_formatted;
      });
      document.querySelectorAll('.product-price[data-variant-id="'+prop+'"] span[data-actual-price]').forEach(el => {
        el.innerText = money_formatted;
      });
      document.querySelectorAll('.product-price[data-variant-id="'+prop+'"] span[data-compare-price]').forEach(el => {
        el.style.removeProperty('display');
      });
      document.querySelectorAll('.product-price[data-variant-id="'+prop+'"]').forEach(el => {
        const next = el.nextElementSibling;
        if (!next || !next.classList.contains('promotional-price')) {
          el.insertAdjacentHTML('afterend', '<p class="promotional-price">Promotional price</p>');
        }
      });
      
      if(prop == c_variant_id){
        document.getElementById("closed_shop_price").value = closed_shop.closed_shop_price;
        document.getElementById("closed_shop_price").disabled = false;
        document.getElementById("closed_shop_token").value = closed_shop.closed_shop_token;
        document.getElementById("closed_shop_token").disabled = false;
        document.getElementById("closed_shop_pricelist").value = pricelist;
        document.getElementById("closed_shop_pricelist").disabled = false;
      }

    }
  }
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};
  

var display_price = function(current_variant_id, isPDP) {
  var variant_id = getUrlParameter("variant");
  if (variant_id == undefined) {
    variant_id = current_variant_id;
  }
  var variant = benefits[variant_id];
  if (variant != null && variant != undefined) {
    var pricelist = getCookie("pricelist");
    var closed_shop = variant[pricelist];
    if (closed_shop != null && closed_shop != undefined) {
      
      var money_formatted = formatMoney(closed_shop.closed_shop_price, theme.moneyFormat);
      var compare_at_price_formatted = formatMoney(closed_shop.compare_price, theme.moneyFormat);

      if(isPDP){
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id] span[data-compare-price], .pdp-top-sticky-bar .product-price[data-variant-id] span[data-compare-price], .custom-pdp-two-col-section .product-price[data-variant-id] span[data-compare-price]').forEach(el => {
            el.innerText = compare_at_price_formatted;
          });
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id] span[data-actual-price], .pdp-top-sticky-bar .product-price[data-variant-id] span[data-actual-price], .custom-pdp-two-col-section .product-price[data-variant-id] span[data-actual-price]').forEach(el => {
            el.innerText = money_formatted;
          });
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id] span[data-compare-price], .pdp-top-sticky-bar .product-price[data-variant-id] span[data-compare-price], .custom-pdp-two-col-section .product-price[data-variant-id] span[data-compare-price]').forEach(el => {
            el.style.removeProperty('display');
          });
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id], .pdp-top-sticky-bar .product-price[data-variant-id], .custom-pdp-two-col-section .product-price[data-variant-id]').forEach(el => {
            const next = el.nextElementSibling;
            if (!next.classList.contains('promotional-price')) {
              el.insertAdjacentHTML('afterend', '<p class="promotional-price">Promotional price</p>');
            }
          });

          document.getElementById("closed_shop_price").value = closed_shop.closed_shop_price;
          document.getElementById("closed_shop_price").disabled = false;
          document.getElementById("closed_shop_token").value = closed_shop.closed_shop_token;
          document.getElementById("closed_shop_token").disabled = false;
          document.getElementById("closed_shop_pricelist").value = pricelist;
          document.getElementById("closed_shop_pricelist").disabled = false;
      }else{
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"] span[data-compare-price]').forEach(el => {
            el.innerText = compare_at_price_formatted;
          });
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"] span[data-actual-price]').forEach(el => {
            el.innerText = money_formatted;
          });
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"] span[data-compare-price]').forEach(el => {
            el.style.removeProperty('display');
          });
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"]').forEach(el => {
            const next = el.nextElementSibling;
            if (!next || !next.classList.contains('promotional-price')) {
              el.insertAdjacentHTML('afterend', '<p class="promotional-price">Promotional price</p>');
            }
          });
      }

      
    }
  }
}
// END 

/****Counry lanage selector start ********/
  const countryLanguageMap = {
 "Australia": [
  	{ label: "English", value: "en" }
  ],
  "Austria": [
  	{ label: "German", value: "de" }, 
  	{ label: "English", value: "en" }
  ],
  "Belgium": [
  	{ label: "Dutch", value: "nl" },
  	{ label: "Français", value: "fr" }, 
  	{ label: "English", value: "en" }
  ],
  "Brazil": [
  	{ label: "Portuguese", value: "pt" }
  ],
  "Canada": [
  	{ label: "Français", value: "fr-ca" },
  	{ label: "English", value: "en" }
  ],
  "Chinese Mainland": [
  	{ label: "English", value: "en" },
  	{ label: "Chinese", value: "zh" }
  ],
  "Denmark": [
  	{ label: "Danish", value: "da" }
  ],
  "Finland": [
  	{ label: "English", value: "en" },
    { label: "Finnish", value: "fi" }
  ],
  "France": [
  	{ label: "Français", value: "fr" }
  ],
  "Germany": [
  	{ label: "German", value: "de" },
  	{ label: "English", value: "en" }
  ],
  "Global": [
  	{ label: "English", value: "en" }
  ],
  "Hong Kong SAR": [
  	{ label: "Chinese", value: "zh-hk" },
  	{ label: "English", value: "en" }
  ],
  "Hungary": [
  	{ label: "Hungarian", value: "hu" }
  ],
  "India": [
  	{ label: "English", value: "en" }
  ],
  "Indonesia": [
  	{ label: "English", value: "en" }
  ],
  "Ireland": [
  	{ label: "English", value: "en" }
  ],
  "Italy": [
  	{ label: "Italian", value: "it" }
  ],
  "Japan": [
  	{ label: "Japanese", value: "ja" },
  	{ label: "English", value: "en" }
  ],
  "Korea, Republic of": [
	  { label: "Korean", value: "ko" }
  ],
  "Luxembourg": [
  	{ label: "Français", value: "fr" },
  	{ label: "English", value: "en" }
  ],
  "Malaysia": [
  	{ label: "English", value: "en" }
  ],
  "Mexico": [
  	{ label: "Spanish", value: "es" }
  ],
  "Netherlands": [
  	{ label: "Dutch", value: "nl" },
  	{ label: "English", value: "en" }
  ],
  "New Zealand": [
  	{ label: "English", value: "en" }
  ],
  "Philipines": [
  	{ label: "English", value: "en" }
  ],
  "Portugal": [
  	{ label: "Portuguese", value: "pt" }
  ],
  "Singapore": [
  	{ label: "English", value: "en" }
  ],
  "Spain": [
  	{ label: "Spanish", value: "es" }
  ],
  "Sweden": [
  	{ label: "Swedish", value: "sv" }
  ],
  "Switzerland": [
  	{ label: "Français", value: "fr" },
  	{ label: "German", value: "de" },
  	{ label: "English", value: "en" },
  ],
  "Taiwan": [
    { label: "Traditional Chinese", value: "zh-tw" },
  	{ label: "English", value: "en" }
  ],
  "Thailand": [
    { label: "Thai", value: "th" },
  	{ label: "English", value: "en" }
  ],
  "United Arab Emirates": [
  	{ label: "English", value: "en" }
  ],
  "United Kingdom": [
  	{ label: "English", value: "en" }
  ],
  "United States": [
  	{ label: "English", value: "en" }
  ],
  "Vietnam": [
    { label: "Vietnamese", value: "vi" },
  	{ label: "English", value: "en" },
  ]
};
  const targetURLSubDomains = ["ca", "ch", "jp", "us", "vn", "my", "nz", "ph", "tw", "hk", "uk", "eu", "mx", "in", "id", "sg", "au", "th", "cl"]


  const countrySelect = document.getElementById('country-select'); //IN JP
  const languageSelect = document.getElementById('language-select'); // en
  const countryContinueBtn = document.getElementById('country-continue-btn');

  countrySelect.addEventListener('change', function () {
     const selectedCountry = this.options[this.selectedIndex].text; 
    const languages = countryLanguageMap[selectedCountry] || [];

    const selectedCountryOption = this.options[countrySelect.selectedIndex];
    const targetUrl = selectedCountryOption.dataset.target;
    const selectedCountryValue = selectedCountryOption.value;
    const shopurl = document.getElementById("shop_url").value;
    
    // Clear existing options
    languageSelect.innerHTML = '<option value="">Select a language</option>';

    // Populate new options
    languages.forEach(language => {
      const option = document.createElement('option');
      option.value = language.value;
      option.textContent = language.label;
      languageSelect.appendChild(option);
    });
  });

countryContinueBtn.addEventListener('click', function () {
  const languageSelectDropdown = document.getElementById('language-select');
  const selectedCountryOption = countrySelect.options[countrySelect.selectedIndex];
  const targetUrl = selectedCountryOption.dataset.target;
  const selectedLanguageOption = languageSelectDropdown.options[languageSelectDropdown.selectedIndex];
  const selectedLanguageValue = selectedLanguageOption.value;
  const selectedCountryValue = selectedCountryOption.value;
  const shopurl = document.getElementById("shop_url").value;
  const baseDomain = 'sennheiser-hearing.com';
  const newDomain = 'https://eu.sennheiser-hearing.com'
  
  const url = new URL(window.location.href);
  if (targetUrl === 'same' ) {
    window.location.href = shopurl + '/' + selectedLanguageValue + '-' + selectedCountryValue;
  }
  else if(targetUrl === 'eu'){
    const { href, pathname } = window.location;
    const firstSegment = pathname.split('/').filter(Boolean)[0] || '';
    const [currentLang, currentCountry] = firstSegment.split('-');

    const targetPair = `${selectedLanguageValue}-${selectedCountryValue}`;
    const targetPairLower = `${selectedLanguageValue}-${selectedCountryValue.toLowerCase()}`;

    let redirectUrl;

    // Case 1: same country
    if (currentCountry === selectedCountryValue.toLowerCase()) {
      redirectUrl = href.replace(firstSegment, targetPairLower);
    }
    // Case 2: different country
    else {
      redirectUrl =
        selectedLanguageValue === 'fi'
          ? `${newDomain}/${targetPairLower}`
          : `${shopurl}/${targetPair}`;
    }

    window.location.href = redirectUrl;
  }
  else if (targetURLSubDomains.includes(targetUrl)) {
    const currentUrl = new URL(window.location.href);
      const currentHostname = currentUrl.hostname;
      const currentSubdomain = currentHostname.split('.')[0];

      const cleanPath = currentUrl.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?:\/|$)/i, "/");

      // if(targetUrl === 'eu'){
      //  const langPrefix = `/${selectedLanguageValue}-${selectedCountryValue.toLowerCase()}`;
      // }else{
      // }
       const langPrefix = selectedLanguageValue !== "en" ? `/${selectedLanguageValue}` : "";


      let redirectUrl = "";
      console.log("<<Test>>2",currentSubdomain,targetUrl);
      if (currentSubdomain === targetUrl) {
        redirectUrl = `https://${currentHostname}${langPrefix}${cleanPath}${currentUrl.search}`;
      } else {
        redirectUrl = `https://${targetUrl}.${baseDomain}${langPrefix}`;
      }
    window.location.href = redirectUrl;
  } else {
    window.location.href = "https://global.sennheiser-hearing.com/?glcountry=" + selectedCountryValue;
  }
});
/****Counry lanage selector end ********/



/**Show cookie sidebar by cooking setting btn click start **/
document.getElementById('cookie-settings').addEventListener('click', function (e) {
  e.preventDefault();
  if (window.OneTrust) {
    OneTrust.ToggleInfoDisplay();
  } else {
    console.warn('OneTrust not found.');
  }
});
/**Show cookie sidebar by cooking setting btn click end **/



document.addEventListener("DOMContentLoaded", function () {
    const select = document.getElementById("language-select");
    if (!select) return;

   setTimeout(function() {
    // if (Weglot.getCurrentLang() == 'en') {
       select.value = "en"; }
    //   // document.querySelectorAll('.japanese-section .japanese-only-section')
    //   //     .forEach(el => {
    //   //       el.style.display = 'none';
    //   //     });

    //  // document.getElementById('japanese-only-section').style.display = 'none';
    // } else if(Weglot.getCurrentLang() == 'ja'){
    //   select.value = "ja";
    //   // document.querySelectorAll('.japanese-section .japanese-only-section')
    //   //     .forEach(el => {
    //   //       el.style.display = 'block';
    //   //     });
      
    // //  document.getElementById('japanese-only-section').style.display = 'block';
    // }}
    , 2000);
  });

  //Show More on Similar Products
  function showMoreProducts() {
    document.getElementById('more-products').style.display = 'flex';
    document.getElementById('show-more-button').style.display = 'none';
  }

/* canvas images */
function productrotation() {
  console.log("productrotation");
  const canvases = document.querySelectorAll(".product360Canvas");
 
  canvases.forEach((canvas) => {
    if (!canvas) return;
 
    const ctx = canvas.getContext("2d");
 
    const productNumber = canvas.dataset.product || "1";
    const frameCount = parseInt(canvas.dataset.framecount, 10) || 1;
    const imageBase = canvas.dataset.imageurl;

    console.log(imageBase);
 
    const images = [];
    let currentFrame = 0;
    let isDragging = false;
    let startX = 0;
   
    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      const fileimage = '//sennheiser-pim.myshopify.com/cdn/shop/files/0_267.webp?v=3841086156881147033';
      const fileimage2 =  "//sennheiser-pim.myshopify.com/cdn/shop/files/";
      //img.src = `${fileimage2}0_${i + 1}.webp`;
      img.src = `${imageBase}0_${i + 1}.webp`;
      //console.log("image src", img.src);
      //img.src = `canvas-images/product${productNumber}/0_${i + 1}.webp`;
      images.push(img);
    }
 
    images[0].onload = function () {
      ctx.drawImage(images[0], 0, 0, canvas.width, canvas.height);
    };
 
    function drawFrame(frameIndex) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(images[frameIndex], 0, 0, canvas.width, canvas.height);
    }
 
    canvas.addEventListener("mousedown", (e) => {
      isDragging = true;
      startX = e.pageX;
    });
 
    canvas.addEventListener("mouseup", () => {
      isDragging = false;
    });
 
    canvas.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
 
      let delta = e.pageX - startX;
      const sensitivity = 1;
 
      if (Math.abs(delta) > 1) {
        const framesToMove = Math.floor(Math.abs(delta) * sensitivity);
 
        currentFrame =
          delta > 0
            ? (currentFrame - framesToMove + frameCount) % frameCount
            : (currentFrame + framesToMove) % frameCount;
 
        drawFrame(currentFrame);
        startX = e.pageX;
      }
    });
  });
}
window.addEventListener("DOMContentLoaded", productrotation);